import { usePersona } from '../../components/hooks/usePersona';

const SPOTLIGHT_CUSTOMER_WRITE_ROLE_NAMES: ReadonlySet<string> = new Set([
  'Account Admin',
  'Policy Holder',
  'Pool Policy Holder',
  'Security Officer',
]);

export type SpotlightUserAccessMode = 'readonly' | 'readwrite';

export function getSpotlightUserAccessMode(
  persona: ReturnType<typeof usePersona>,
  roleName: string | undefined | null,
  isSpotlightV2PgSource: boolean
): SpotlightUserAccessMode {
  if (persona.isCowbell) {
    if (isSpotlightV2PgSource) {
      return 'readonly';
    }

    return 'readwrite';
  }

  if (SPOTLIGHT_CUSTOMER_WRITE_ROLE_NAMES.has(roleName?.trim())) {
    return 'readwrite';
  }

  return 'readonly';
}
